var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg060Pencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "059---Note",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m51 17.49v35.51c0 3.3137085-2.6862915 6-6 6h-38c-3.3137085 0-6-2.6862915-6-6v-38c0-3.3137085 2.6862915-6 6-6h35.51z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m48 17.49v35.51c0 3.3137085-2.6862915 6-6 6h3c3.3137085 0 6-2.6862915 6-6v-35.51z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m52.88 15.61-3.53 3.54-8.49-8.49 3.53-3.54z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m28.84 39.65c.7814829-.7814829.7814829-2.0485171 0-2.83s-2.0485171-.7814829-2.83 0c.7814829-.7814829.7814828-2.048517-.0000001-2.8299999s-2.048517-.781483-2.8299999-.0000001c.7814829-.7814829.7814829-2.0485171 0-2.83s-2.0485171-.7814829-2.83 0l20.51-20.5 8.49 8.49z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m57.83 10.66-4.95 4.95-8.49-8.49 4.95-4.95c1.5642825-1.55978389 4.0957175-1.55978389 5.66 0l2.83 2.83c1.5597839 1.56428251 1.5597839 4.09571749 0 5.66z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m57.83 5-2.83-2.83c-1.1353341-1.13462014-2.8389452-1.4806969-4.327-.879.4969825.20070644.9483315.49967838 1.327.879l2.83 2.83c1.5597839 1.56428251 1.5597839 4.09571749 0 5.66l-3.45 3.45 1.5 1.5 4.95-4.95c1.5597839-1.56428251 1.5597839-4.09571749 0-5.66z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m28.84 39.65-7.69 3.22c-.5903963-1.9237589-2.0962411-3.4296037-4.02-4.02l3.22-7.69c.5055308-.5055308 1.242358-.7029631 1.9329259-.5179259.690568.1850371 1.2299629.724432 1.415 1.415.1850372.6905679-.0123951 1.4273951-.5179259 1.9329259.7814829-.7814829 2.0485171-.7814829 2.83 0s.7814829 2.0485171 0 2.83c.5055308-.5055308 1.242358-.7029631 1.9329259-.5179259.690568.1850371 1.2299629.724432 1.415 1.415.1850372.6905679-.0123951 1.4273951-.5179259 1.9329259z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m21.15 42.87-4.65 1.94c-.3748238.1580752-.8080493.0733416-1.0956954-.2143046-.2876462-.2876461-.3723798-.7208716-.2143046-1.0956954l1.94-4.65c1.9237589.5903963 3.4296037 2.0962411 4.02 4.02z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m1 53c0 3.3137085 2.6862915 6 6 6h3c-3.3137085 0-6-2.6862915-6-6v-38c0-3.3137085 2.6862915-6 6-6h-3c-3.3137085 0-6 2.6862915-6 6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m0 45h2v8h-2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff414c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m1 46c.55228475 0 1-.4477153 1-1v-30c.00330612-2.7600532 2.23994685-4.9966939 5-5h29c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1h-29c-3.86393756.00495836-6.99504164 3.1360624-7 7v30c0 .2652165.10535684.5195704.29289322.7071068s.44189029.2928932.70710678.2928932z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 60h38c3.8639376-.0049584 6.9950416-3.1360624 7-7v-29c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v29c-.0033061 2.7600532-2.2399468 4.9966939-5 5h-38c-2.76005315-.0033061-4.99669388-2.2399468-5-5 0-.5522847-.44771525-1-1-1s-1 .4477153-1 1c.00495836 3.8639376 3.13606244 6.9950416 7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m52.879 5.707c.3902047-.390639.3899699-1.02360173-.0005243-1.41395122-.3904943-.3903495-1.0234571-.3903495-1.4139514 0-.3904942.39034949-.390729 1.02331222-.0005243 1.41395122.1875683.18777704.4420908.29328666.7075.29328666s.5199317-.10550962.7075-.29328666z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m41.564 15.606c-.3904999-.3903819-1.0235001-.3903819-1.414 0l-13.434 13.436c-.2599566.2510745-.3642126.6228779-.2726972.9725073.0915155.3496295.3645604.6226744.7141899.7141899.3496294.0915154.7214328-.0127406.9725073-.2726972l13.434-13.435c.187777-.1875683.2932867-.4420908.2932867-.7075s-.1055097-.5199317-.2932867-.7075z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42.979 18.436-13.435 13.434c-.2599566.2510745-.3642126.6228779-.2726972.9725073.0915155.3496295.3645604.6226744.7141899.7141899.3496294.0915154.7214328-.0127406.9725073-.2726972l13.436-13.434c.3904653-.3907415.3902415-1.0240347-.0005-1.4145s-1.0240347-.3902415-1.4145.0005z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m19.645 30.456c-.0922104.0919183-.1655834.2009588-.216.321l-5.158 12.323c-.3211412.750143-.1543599 1.620159.4214241 2.1983622.575784.5782033 1.445093.7486309 2.1965759.4306378l12.334-5.161c.1200412-.0504166.2290817-.1237896.321-.216l24.042-24.039 4.949-4.949c1.9492694-1.95398226 1.9492694-5.11701774 0-7.071l-2.828-2.828c-1.9539823-1.94926942-5.1170177-1.94926942-7.071 0l-4.949 4.949zm1.526 1.34c.3904572-.3052071.9466994-.273544 1.3.074.3903819.3904999.3903819 1.0235001 0 1.414-.3910176.3915699-.3905699 1.0259824.001 1.417s1.0259824.3905699 1.417-.001c.3951446-.3780366 1.0178554-.3780366 1.413 0 .1875494.1874927.2929434.4418052.293.707.001124.2651352-.1044714.5195734-.293.706-.3910176.3904653-.3914653 1.0239824-.001 1.415s1.0239824.3914653 1.415.001c.3904999-.3903819 1.0235001-.3903819 1.414 0 .345408.3542441.3769777.9088478.074 1.3l-6.51 2.721c-.6761425-1.423457-1.8231267-2.5697347-3.247-3.245zm-5.058 12.087 1.561-3.731c.9398733.4695354 1.7020319 1.231343 2.172 2.171zm33.23-26.155-2.828-2.828c-.2508919-.260128-.6226186-.3646423-.9723089-.2733733s-.6229254.3641179-.7146889.7136787c-.0917634.3495609.0122249.721435.2719978.9726946l2.828 2.829-17.807 17.808c-.4557798-.9999201-1.4332268-1.6603051-2.531-1.71-.084317-1.5266777-1.3033223-2.745683-2.83-2.83-.0505991-1.0974736-.7106952-2.0744931-1.71-2.531l17.808-17.808 1.414 1.414c.2525868.2527654.6208353.3515768.96603.259213.3451946-.0923639.6148921-.3618707.7075-.707s-.0059432-.7134476-.25853-.966213l-1.415-1.414 2.122-2.122 2.119 2.119 4.947 4.947zm.707-14.849c.5626237-.56271905 1.3257625-.87885933 2.1215-.87885933s1.5588763.31614028 2.1215.87885933l2.828 2.828c.562719.56262374.8788593 1.32576248.8788593 2.1215s-.3161403 1.55887626-.8788593 2.1215l-4.242 4.242-4.243-4.242 1.414-1.415c.2599566-.25107447.3642126-.62287789.2726972-.97250732-.0915155-.34962944-.3645604-.6226744-.7141899-.71418984-.3496294-.09151544-.7214328.01274058-.9725073.27269716l-1.414 1.414-1.414-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 14h1c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-1c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 14c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-15c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m46 52v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 46h5c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-5c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42 44h-16c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h16c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 51h23c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-23c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42 49h-7c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h7c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg060Pencil);
export default __webpack_public_path__ + "static/media/060-pencil.7528b0bed7f42ae14a0bef65ce752d2c.svg";
export { ForwardRef as ReactComponent };